<template>
  <el-dialog class="detail"
             :visible.sync="detailVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1000px"
             title="招聘详情">
    <el-form ref="detailForm"
             :model="detailForm"
             label-width="100px"
             :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="所在部门"
                        size="small"
                        :rules="[
                                { required: true, message: '请选择所在部门' }
                            ]"
                        prop="depart_id">
            <el-input disabled
                      size="small"
                      v-model="detailForm.depart_name">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="招聘职位"
                        :rules="[{ required: true, message: '请输入招聘职位' }]"
                        prop="role_id"
                        size="small">
            <el-input disabled
                      size="small"
                      v-model="detailForm.role_name">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="招聘类型"
                        :rules="[{ required: true, message: '请输入招聘类型' }]"
                        prop="type"
                        size="small">
            <el-input disabled
                      size="small"
                      v-model="detailForm.type_cn">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作年限"
                        prop="experience"
                        size="small">
            <el-input disabled
                      size="small"
                      v-model="detailForm.experience">
              <template slot="append">年</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="招聘人数"
                        prop="people"
                        :rules="[{ required: true, message: '请输入招聘人数' }]"
                        size="small">
            <el-input disabled
                      size="small"
                      v-model.number="detailForm.people">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到岗日期"
                        prop="people"
                        :rules="[{ required: true, message: '请选择到岗日期' }]"
                        size="small">
            <el-input disabled
                      size="small"
                      v-model.number="detailForm.req_work_time">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="职责要求"
                        :rules="[{ required: true, message: '请输入职责要求' }]"
                        prop="duty"
                        size="small">
            <el-input disabled
                      type="textarea"
                      :autosize="{ minRows: 6, maxRows: 8 }"
                      resize="none"
                      size="small"
                      v-model="detailForm.duty">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="任职要求"
                        :rules="[{ required: true, message: '请输入任职要求' }]"
                        prop="content"
                        size="small">
            <el-input type="textarea"
                      disabled
                      maxlength="500"
                      :autosize="{ minRows: 6, maxRows: 8 }"
                      resize="none"
                      size="small"
                      v-model="detailForm.content">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="详细说明"
                        size="small">
            <el-input disabled
                      type="textarea"
                      maxlength="500"
                      :autosize="{ minRows: 6, maxRows: 8 }"
                      resize="none"
                      size="small"
                      v-model="detailForm.remark">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">

        </el-col>
      </el-row>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button size="small"
                 @click="detailVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import * as api from "@/http/api.js";
import selectbutton from "@/comon/components/selectbutton";
export default {
  data () {
    var setExperience = (rule, value, callback) => {
      setTimeout(() => {
        if (value > 50) {
          callback(new Error('最大不超过50年'));
        } else {
          callback();
        }
      }, 100);
    }
    return {
      detailForm: {
        experience: 1,
        people: 1,
        role_id: '',
        content: '',
        duty: '',
        type: '',
        people: '',
        experience: '',
        req_work_time: '',
        remark: '',
        depart_id: ''
      },
      roleList: [],
      recruitList: [],
      rules: {
        experience: [
          { required: true, message: '工作年限不能为空' },
          { validator: setExperience, trigger: 'blur' }
        ]
      },

      tableItem: {}
    };
  },
  methods: {
    /**
     * 新增窗口关闭
     */
    closeDialog () {
      this.detailForm = {
        experience: 1,
        people: 1,
        role_id: '',
        content: '',
        duty: '',
        type: '',
        people: '',
        experience: '',
        req_work_time: '',
        remark: '',
        depart_id: ''
      };
      this.$refs["detailForm"].clearValidate();
      this.$refs["detailForm"].resetFields();
      if (this.$refs.selectBtn) {
        this.$refs.selectBtn.clearHandle();
      }
      this.$emit("update:detailVisible", false);
    },
    recruitment () {
      oaApi.recruitment({}, "get", this.tableItem.id).then(res => {
        if (res) {
          this.detailForm = res.data
        }
      });
    },
    getRoleList () {
      oaApi.roleSelect({}, "get").then(res => {
        if (res) {
          this.roleList = res.data;
        }
      });
    },
    recruitmentRecruit () {
      oaApi.recruitmentRecruit({}, "get").then(res => {
        if (res) {
          this.recruitList = res.data;
        }
      });
    },
    /**
     *  获取组织架构信息
     */
    depart () {
      api.depart({}, "get").then(res => {
        if (res) {
          this.list = res.data;
        }
      });
    },
  },
  props: {
    detailVisible: Boolean,
    tableItem: Object
  },
  components: {
    selectbutton: selectbutton,
  },
  watch: {
    mixed: {
      handler (newValue) {
        if (newValue.detailVisible) {
          this.tableItem = newValue.tableItem
          this.getRoleList()
          this.recruitmentRecruit()
          this.depart()
          this.recruitment()
        }
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    mixed () {
      const { tableItem, detailVisible } = this
      return {
        tableItem, detailVisible
      }
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
